export default __webpack_public_path__ + "static/media/submitBackgroundXXL.7a89fb6d.svg";